import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

import { UserService, WindowRef, LanguageService, MenuService, PageService } from '@shared/services';
import { UserQuery } from '@shared/queries';
import { User, ParseObject, Language, MenuNode, Page } from '@shared/data';

declare var ga: any;
declare var $: any;

@Component({
  moduleId: 'module.id',
  selector: 'navbar',
  styles: [require('./navbar.component.scss')],
  template: require('./navbar.component.html'),
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, AfterViewInit {
  @Output()
  public menuClick: EventEmitter<void>;

  public navigation: Observable<MenuNode>;
  public home: Observable<Page>;
  public cfm: Observable<Map<string, any>>;
  public lang: Observable<string>;

  public search: boolean;

  public searchText: string;

  public language: Observable<Language>;
  public languages: Observable<Language[]>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private languageService: LanguageService,
    private menuService: MenuService,
    private pageService: PageService,
    public windowRef: WindowRef) {

    this.languages = this.languageService.find();
    this.menuClick = new EventEmitter();
  }

  public ngOnInit() {
    let menu = this.menuService.root();

    this.lang = this.languageService.getCurrentLang();
    this.home = this.pageService.home();

    this.navigation = menu.switchMap(o => {
      let nav = o.children.find(v => v.name == MenuNode.NAVIGATION);
      let pages = [];

      nav.children.forEach(v => {
        if (v.page) {
          pages.push(v.page);
        }
      });

      return ParseObject.rx().fetchAll(pages, {}).map(p => nav);
    });

    this.cfm = this.lang.switchMap(lang => {
      return this.home.map(
        page => {
          let map = new Map<string, string>();

          page.customFields.forEach(o => {
            let v = o.value[lang] || o.value[Language.DEFAULT_LANG];

            map.set(o.key, v);
          });

          return map;
        }
      );
    });

    this.language = this.route.queryParams.combineLatest(this.languages).map(o => {
      let params = o[0];
      let languages = o[1];
      let lang = params['lang'] || this.languageService.defaultLang;

      return languages.find(o => o.code == lang);
    });
  }

  public ngAfterViewInit() {

  }

  public onLangClick(lang: Language) {
    this.router.navigate([], { queryParams: {lang: lang.code }});
  }

  public onSearch() {
    this.router.navigate(['/search'], { queryParams: {s: this.searchText }});
    this.search = false;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/navbar/navbar.component.ts